import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Alert } from '../../shared/components/alert/alert';
import { AlertData } from './alert-data';

@Injectable({
  	providedIn: 'root'
})

export class AlertService {
  	constructor(private dialog: MatDialog) { }

	openAlert(data: AlertData): void {
		this.dialog.open(Alert, {
			width        : '400px',
			disableClose : true,
			data         : data
		});
	}

	success(message: string, title: string): void {
    	this.openAlert({ message, type: 'success', title });
  	}

	error(message: string, title: string): void {
    	this.openAlert({ message, type: 'error', title });
  	}

	info(message: string, title: string): void {
    	this.openAlert({ message, type: 'info', title });
  	}

	warning(message: string, title: string): void {
    	this.openAlert({ message, type: 'warning', title });
  	}
}